import moment from 'moment';

export default (value) => {
  if (value) return moment(value).format('DD/MM/YYYY');
  return undefined;
};
